__webpack_require__.p = "https://ui.cltpstatic.com/ct-acropolis/beta-offers-config-dashboard/";